// @flow
import * as React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { getRoute } from '../app/router';
import {
  Box,
  Button,
  Card,
  Container,
  Divider,
  Fade,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material';
import { useMaPlansCount } from '@coverright/data-access/medicare';
import { getDisclamers, getStoredUser } from '@coverright/utils';
import { CRModal, ModalCloseButton } from '@coverright/ui/shared';

const getProgress = (pathname: string) => {
  const firstPartRoutes = [getRoute('zip'), getRoute('basicInfo'), getRoute('personalInfo')];
  const firstPartIndex = firstPartRoutes.indexOf(pathname);
  if (firstPartIndex !== -1) {
    return firstPartIndex * 40;
  }

  const secondPartRoutes = [
    getRoute('situation'),
    getRoute('doctors'),
    getRoute('drugs'),
    getRoute('pharmacy'),
    getRoute('specialProgram'),
    getRoute('payment'),
    getRoute('planType'),
  ];
  const secondPartIndex = secondPartRoutes.indexOf(pathname);
  if (secondPartIndex !== -1) {
    return (secondPartIndex + 1) * (100 / secondPartRoutes.length);
  }

  return 0;
}


export const QuizLayout = () => {
  const location = useLocation();
  const progress = getProgress(location.pathname);
  const [openDisclaimer, setOpenDisclaimer] = React.useState(false);
  const { maPlansCount, maOrgCount } = useMaPlansCount(getStoredUser()?.zip);

  return <Stack flex={1}>
    <LinearProgress variant="determinate" value={progress} sx={{height: 8, bgcolor: '#e2e8f0'}} />

    <CRModal
      width={740}
      open={openDisclaimer}
      onClose={() => setOpenDisclaimer(false)}
      paperPadding={'30px'}
      paperSx={{
        bgcolor: '#FFF',
      }}
    >
      <>
        <ModalCloseButton sx={{position: 'absolute', right: 16, top: 16}} onClick={() => setOpenDisclaimer(false)} />
        <Box>
          <Typography sx={{fontWeight: 600, fontSize: 24, pb: 2}}  color={'text.secondary'}>Medicare Disclaimers</Typography>
          <Divider sx={{mx: '-30px'}} />
          <Typography color={'text.secondary'}>
            <br/>
            {getDisclamers('PERSONAL_INFO_ONBOARDING', {maOrgCount, maPlansCount})}
            <br/>
            <br/>
          </Typography>
          <Divider sx={{mx: '-30px'}} />
          <Stack alignItems={'flex-end'}>
            <Button variant={'contained'} size={'small'} sx={{mt: 3, minWidth: 91}} onClick={() => setOpenDisclaimer(false)}>
              Close
            </Button>
          </Stack>
        </Box>
      </>
    </CRModal>

    <Container sx={{flex: 1, display: 'flex', flexDirection: 'column'}}>
      <Container maxWidth="sm" sx={{pt: {xs:4, sm: 10}, pb: 8, px: '0!important', flex: 1, display: 'flex', flexDirection: 'column'}}>
        <Stack gap={{xs: 2, sm: 4}}>
          <Outlet />

          <Fade key={location.pathname} in={[getRoute('zip'), getRoute('basicInfo')].includes(location.pathname)} timeout={500}>
            <Typography color={'text.secondary'} sx={{textDecoration: 'underline', textAlign: 'center', cursor: 'pointer', fontWeight: 500}}
                        onClick={() => setOpenDisclaimer(true)}>
              View Medicare Disclaimers
            </Typography>
          </Fade>
        </Stack>
      </Container>
    </Container>
  </Stack>
};

